$(function() {
  $('select.shortcode_cemetery_terms').change(function() {
    var target = $(this)
      .prev()
      .val()
    var pref = $(this).val()
    var attribute = target.split('-')[0].trim()
    var choice = target.split('-')[1].trim()
    var path = '/ohaka/pref-' + pref + '/cond-' + attribute + '-' + choice + '/'
    $(this)
      .next()
      .attr('href', path)
    $(this).addClass('is-selected')
    $(this)
      .next()
      .addClass('is-active')
    if ($(this).val() == '') {
      $(this).removeClass('is-selected')
      $(this)
        .next()
        .removeClass('is-active')
    }
  })
})
